export default __webpack_public_path__ + "static/media/momo.92cda268.svg";